/**
 * Resiliencia del Excel (v1 single / v2 single / Consolidado) ante una falla
 * de Extra-Servicios (OPB, 2026-10-01: un 404 por bug de orden de rutas tiró
 * abajo el Consolidado completo — ver PR #368 para el fix de la ruta).
 *
 * Contrato: si Extra-Servicios no se pudo obtener, el Excel se genera IGUAL
 * con el resto de las hojas, y la hoja "Servicios Extra" muestra esta fila en
 * vez de quedar vacía o directamente no existir — una hoja ausente o sin
 * filas es indistinguible de "esta liquidación no tiene servicios extra", y
 * eso es exactamente lo que NO hay que mostrar cuando en realidad el fetch
 * falló.
 */
export const EXTRA_SERVICIOS_FALLBACK_MESSAGE =
    'No se pudo cargar Servicios Extra. Vuelve a generar el Excel y, si el problema persiste, comunícate con soporte.';

export type ExtraServiciosRow = Record<string, string | number | null>;

/** Fila única que reemplaza las filas reales cuando el fetch de Extra-Servicios falló. */
export function buildExtraServiciosFallbackRows(): ExtraServiciosRow[] {
    return [{ Mensaje: EXTRA_SERVICIOS_FALLBACK_MESSAGE }];
}

/**
 * Resuelve qué filas lleva la hoja "Servicios Extra": las reales si el fetch
 * funcionó, o la fila de error visible si falló. Cuando `failed` es true se
 * ignoran las filas recibidas a propósito — no deben mezclarse datos
 * parciales con el aviso de error.
 */
export function resolveServiciosExtraRows(
    rows: ExtraServiciosRow[],
    failed: boolean
): ExtraServiciosRow[] {
    return failed ? buildExtraServiciosFallbackRows() : rows;
}
